module.exports = __webpack_public_path__ + "media/vans/van-icon-15cbd30e.svg";